const Coupons = () => import(/* webpackChunkName: "Coupons" */ "@/views/coupons/Coupons");
const FAQ = () => import(/* webpackChunkName: "Coupons FAQ" */ "@/views/coupons/FAQ");

const couponRoutes = [
  {
    path: "coupons",
    name: "Coupons",
    redirect: {
      name: "Coupons FAQ"
    },
    component: Coupons,
    children: [
      {
        path: "faq",
        name: "Coupons FAQ",
        component: FAQ
      }
    ]
  }
];

export default couponRoutes;